import React, { useState, useEffect } from 'react';

const API_BASE = "https://adria.terrier-ule.ts.net";


async function downloadAllPdf(imgDataList, filename) {
  const validImgs = imgDataList.filter(Boolean);
  if (!validImgs.length) { alert('이미지가 없습니다'); return; }
  if (!window.jspdf) {
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  const { jsPDF } = window.jspdf;
  let pdf = null;
  for (const imgData of validImgs) {
    const img = new Image();
    img.src = imgData;
    await new Promise(r => { img.onload = r; });
    const isLandscape = img.width > img.height;
    if (!pdf) {
      pdf = new jsPDF({ orientation: isLandscape ? 'landscape' : 'portrait', unit: 'px', format: [img.width, img.height] });
    } else {
      pdf.addPage([img.width, img.height], isLandscape ? 'landscape' : 'portrait');
    }
    pdf.addImage(imgData, 'WEBP', 0, 0, img.width, img.height);
  }
  pdf.save(filename + '.pdf');
}

export default function ContractView() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [info,       setInfo]       = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [imgCache,   setImgCache]   = useState({});
  const [imgLoading, setImgLoading] = useState({});
  const [error,      setError]      = useState('');

  useEffect(() => {
    if (!token) { setError('잘못된 링크입니다'); return; }
    fetch(`${API_BASE}/api/contracts/share/${token}`)
      .then(r => r.ok ? r.json() : r.json().then(d => { throw new Error(d.detail); }))
      .then(d => { setInfo(d); if (d.total_pages) setTotalPages(d.total_pages); fetchImage(0); })
      .catch(e => setError(e.message || '링크를 불러올 수 없습니다'));
  }, [token]);

  const fetchImage = async (page) => {
    if (imgCache[page] !== undefined || imgLoading[page]) return;
    setImgLoading(l => ({ ...l, [page]: true }));
    try {
      const res  = await fetch(`${API_BASE}/api/contracts/share/${token}/image/${page}`);
      const data = await res.json();
      if (data.data) {
        setImgCache(c => ({ ...c, [page]: data.data }));
        if (data.total_pages > 1 && page === 0) {
          setTotalPages(data.total_pages);
          for (let p = 1; p < data.total_pages; p++) {
            fetch(`${API_BASE}/api/contracts/share/${token}/image/${p}`)
              .then(r => r.json())
              .then(d => { if (d.data) setImgCache(c => ({ ...c, [p]: d.data })); })
              .catch(() => {});
          }
        }
      }
    } catch {}
    finally { setImgLoading(l => ({ ...l, [page]: false })); }
  };

  if (error) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh',
                  backgroundColor: '#f3f4f6', fontFamily: '"Pretendard", sans-serif' }}>
      <div style={{ textAlign: 'center', color: '#dc2626', fontSize: '15px' }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>⚠️</div>
        {error}
      </div>
    </div>
  );

  if (!info) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#111827' }}>
      <div style={{ width: '36px', height: '36px', border: '4px solid #4f46e5', borderTopColor: 'transparent',
                    borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  const fmtDate = (s) => s ? s.slice(0, 10) : '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#111827',
                  fontFamily: '"Pretendard", sans-serif' }}
      onContextMenu={e => e.preventDefault()}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      {/* 헤더 */}
      <div style={{ padding: '14px 16px', backgroundColor: '#1f2937', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '15px' }}>📄 계약서</span>
          <span style={{ color: '#9ca3af', fontSize: '12px', marginLeft: '8px' }}>{info.room_no} · {info.user_name}</span>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <button onClick={() => downloadAllPdf(Array.from({length:totalPages},(_,i)=>imgCache[i]).filter(Boolean), `${info.room_no}_${info.user_name}_계약서`)}
            style={{ padding:'6px 12px', backgroundColor:'#dc2626', color:'#fff', border:'none', borderRadius:'8px', fontSize:'12px', fontWeight:'bold', cursor:'pointer' }}>
            📄 PDF
          </button>
          <span style={{ color: '#6b7280', fontSize: '11px' }}>~{fmtDate(info.expires_at)}</span>
        </div>
      </div>

      {/* 스크롤 뷰어 */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px', display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <div key={i} style={{ width: '100%', maxWidth: '800px' }}>
            {imgCache[i] ? (
              <img src={imgCache[i]} alt={`p${i+1}`} draggable={false}
                onContextMenu={e => e.preventDefault()}
                style={{ width: '100%', borderRadius: '8px', display: 'block',
                         userSelect: 'none', WebkitUserSelect: 'none', pointerEvents: 'none' }} />
            ) : (
              <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'200px', color:'#9ca3af', fontSize:'13px' }}>
                <div style={{ width:'32px', height:'32px', border:'3px solid #4f46e5', borderTopColor:'transparent',
                              borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
              </div>
            )}
            {i < totalPages - 1 && <div style={{ height:'1px', backgroundColor:'#1e293b', margin:'12px 0' }} />}
          </div>
        ))}
      </div>

      {/* 하단 안내 */}
      <div style={{ padding: '10px', textAlign: 'center', backgroundColor: '#1f2937',
                    color: '#4b5563', fontSize: '11px' }}>
        이 링크는 {fmtDate(info.expires_at)}까지 유효합니다
      </div>
    </div>
  );
}
